var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2942_152458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3.9987H3.33333C2.76067 3.9987 2.21867 3.7507 1.84333 3.3327C2.21 2.92336 2.74267 2.66536 3.33333 2.66536H15.3333C16.2053 2.66136 16.2047 1.33536 15.3333 1.33203H3.33333C1.49267 1.33203 0 2.8247 0 4.66536V11.332C0 13.1727 1.49267 14.6654 3.33333 14.6654H14C15.1047 14.6654 16 13.77 16 12.6654V5.9987C16 4.89403 15.1047 3.9987 14 3.9987ZM13.3333 9.9987C12.4613 9.9947 12.4613 8.66936 13.3333 8.66536C14.2053 8.66936 14.2053 9.9947 13.3333 9.9987Z",
    fill: "#4A78B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2942_152458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewNotification);
export default __webpack_public_path__ + "static/media/overview-notification.3ededcd0d7dabd16d9cef0d194dcc379.svg";
export { ForwardRef as ReactComponent };